import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { APP_ROUTES } from '../constants/app-routes';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {

    const user : any= this.authService.getUserData(); 
    if (user && user.role_id === 1) {
      return true;
    }
  
    this.router.navigate(['/', APP_ROUTES.commissions.base, APP_ROUTES.commissions.list]);
    return false;
  }
}